export default __webpack_public_path__ + "48463dbb54a8cedf8157e02343048b91.png";